import type { ColumnDef } from '@tanstack/react-table';
import { MemberNameCell } from '@/components/common/DataTable';
import { EmptyValue } from '@/components/common/EmptyValue';

interface AreaManagerIdentity {
  amName: string | null;
  amHrEmpId: string | null;
  amMobile: string | null;
}

export function getAmNameColumn<TRow extends AreaManagerIdentity>(): ColumnDef<TRow, unknown> {
  return {
    id: 'amName',
    header: 'AM Name',
    cell: ({ row }) => {
      const { amName, amHrEmpId, amMobile } = row.original;
      if (amName === null) return <EmptyValue />;

      return <MemberNameCell member={{ name: amName, hrEmpId: amHrEmpId, mobile: amMobile }} />;
    },
  };
}
